import {
  ComponentMultiStyleConfig,
  HStack,
  Text,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import { CMFormCommentEditButton } from "../../button";
import { CMDatetimeText } from "../../../../text";
import { CMFormCommentHeaderUserName } from "../CMFormCommentHeaderUserName/CMFormCommentHeaderUserName";

export type CMFormCommentTextProps = {
  userName?: string;
  date?: Date;
  comment?: string;

  /**
   * trueなら、編集開始または編集することが可能である。
   */
  editable: boolean;
  /**
   * 編集ボタンを押したときのコールバック。
   */
  onEdit?: () => void;
  /**
   * 編集ボタンのラベル・Ariaラベル。
   * 編集可能の場合、設定を強く推奨する。
   */
  editButtonLabel?: string;
} & ComponentStyleProps;

export const CMFormCommentText = ({
  userName,
  date,
  comment,

  editable,
  onEdit,
  editButtonLabel,

  sx,
  ...rest
}: CMFormCommentTextProps) => {
  const styles = useMultiStyleConfig("CMFormCommentTextStyles");

  return (
    <VStack sx={{ ...styles.container, ...sx }} spacing={0} {...rest}>
      <HStack spacing={2} sx={styles.header}>
        <CMFormCommentHeaderUserName value={userName} sx={styles.userName} />
        <CMDatetimeText value={date} sx={styles.date} />
        {editable ? (
          <CMFormCommentEditButton
            size="sm"
            ariaLabel={editButtonLabel}
            onClick={onEdit ?? (() => {})}
          />
        ) : null}
      </HStack>
      <Text sx={styles.comment}>{comment}</Text>
    </VStack>
  );
};

export const CMFormCommentTextStyles: ComponentMultiStyleConfig = {
  parts: ["container", "header", "userName", "date", "comment"],
  baseStyle: {
    container: {
      alignItems: "flex-start",
    },
    header: {
      minH: "24px",
    },
    userName: {},
    date: {
      pt: "2px",

      fontSize: "xs",
      fontWeight: "normal",
      color: "gray.500",
    },
    comment: {
      fontSize: "sm",
      color: "gray.900",
      whiteSpace: "pre-wrap",
      wordBreak: "break-all",
    },
  },
};
